<template>
  <div id="app" :class="$t('languages') == 'EN' ? 'en_font' : 'zh_font'">
    <router-view />
  </div>
</template>

<script>
import { changeFavicon, configTitle } from "@/global";
export default {
  name: "App",
  mounted() {
    changeFavicon();
    configTitle();
  },
};
</script>
<style lang="less">
@import url("./assets/css/base.css");
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #fff;
}
.zh_font {
  font-family: FZLanTYJW_Zhun, Alibaba PuHuiTi, PingFang SC, Microsoft YaHei,
    Avenir, Helvetica, Arial, sans-serif;
}
.zh_font {
  font-family: PingFang SC, Avenir, Helvetica, Arial, sans-serif,
    Microsoft YaHei;
}
.en_font {
  font-family: PingFang SC, Avenir, Helvetica, Arial, sans-serif,
    Microsoft YaHei;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
